import { render, staticRenderFns } from "./lahi-vhk.vue?vue&type=template&id=b4f6dece&scoped=true&lang=pug"
import script from "./lahi-vhk.vue?vue&type=script&lang=js"
export * from "./lahi-vhk.vue?vue&type=script&lang=js"
import style0 from "./lahi-vhk.vue?vue&type=style&index=0&id=b4f6dece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f6dece",
  null
  
)

export default component.exports